import api from './api'
import type { AuthToken } from '../types/index'

function getOrCreateDeviceId(): string {
  const key = 'device_id'
  let id = localStorage.getItem(key)
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem(key, id)
  }
  return id
}

export type ActivityUser = {
  id: number
  displayName: string
  role: string
  lastLoginAt: string | null
  deviceCount: number
}

export type ActivityRunner = ActivityUser & {
  runnerNumber: number
  vanNumber: number
}

export const authService = {
  async login(username: string, password: string): Promise<AuthToken> {
    const deviceId = getOrCreateDeviceId()
    const response = await api.post('/auth/login', { username, password, deviceId })
    return response.data
  },

  async logout(): Promise<void> {
    const deviceId = localStorage.getItem('device_id')
    try {
      if (deviceId) await api.post('/auth/logout', { deviceId })
    } catch {
      // ignore — still clear local state
    }
    localStorage.removeItem('auth_token')
    localStorage.removeItem('user_role')
    localStorage.removeItem('runner_id')
    localStorage.removeItem('runner_number')
  },

  async logoutAll(): Promise<void> {
    await api.post('/auth/logout-all')
  },

  async getServerTime(): Promise<{ timestamp: string; unix: number }> {
    const response = await api.get('/auth/time')
    return response.data
  },

  async getActivity(): Promise<{ users: ActivityUser[]; runners: ActivityRunner[] }> {
    const response = await api.get('/auth/activity')
    return response.data
  },

  getToken(): string | null {
    return localStorage.getItem('auth_token')
  },

  getRole(): 'admin' | 'viewer' | null {
    return (localStorage.getItem('user_role') as 'admin' | 'viewer' | null) || null
  },

  isAuthenticated(): boolean {
    return !!this.getToken()
  },
}
